// Login/Logout
export const SIGN_OUT = 'SIGN_OUT';

// Common
export const SET_LOADER = "SET_LOADER";
export const SET_MESSAGE = "SET_MESSAGE";
export const SET_USERINFO = "SET_USERINFO";
export const SET_AUTHORISED_FLAG = "SET_AUTHORISED_FLAG";
export const IS_SAFARI_AUTOFILL_VISISBLE = "IS_SAFARI_AUTOFILL_VISISBLE";
export const SET_FEATURE_FLAG = "SET_FEATURE_FLAG";

// Meeting & Symposia
export const GET_COMMITTEE_LIST = "GET_COMMITTEE_LIST";
export const GET_EVENT_LIST = "GET_EVENT_LIST";

//My Schedule
export const MY_SCHEDULE_VALUES = "MY_SCHEDULE_VALUES";
export const MEETING_SUBMIT_SELECTED_COMMITTEES ="MEETING_SUBMIT_SELECTED_COMMITTEES";
export const COMMITTEE_OPTIONS = "COMMITTEE_OPTIONS";
export const MEETING_LIST = "MEETING_LIST";
export const ADD_CUSTOM_MEETINGS = "ADD_CUSTOM_MEETINGS";
export const CUSTOM_MEETINGS = "CUSTOM_MEETINGS";
export const MEETINGS = "MEETINGS";
export const SET_ENTITLEMENTINFO= "SET_ENTITLEMENTINFO";
